export default __webpack_public_path__ + "static/media/Forget.8e319c4c.svg";